module.exports = __webpack_public_path__ + "img/greenTrees2.2d8d9f3d.jpg";